export default __webpack_public_path__ + "static/media/016.27d2fc71.jpg";